import { leaveDetailConstants } from "../constant/leaveDatail.constants";
import { leaveDetail } from "../services/leaveDetail.service";
import CONSTANT from "../constant/constant";
import functionCommon from "../common/function";

const _errorCode = CONSTANT.errorCode;

export const getLeaveDetail = (data) => {
    if (functionCommon.checkRequestApiTime()) {
        return functionCommon.logout();
    }
    return (dispatch) => {
        dispatch(loading());
        leaveDetail.list(data).then((res) => {
            if (!res) return;
            switch (res["http_code"]) {
                case _errorCode.APISuccess:
                    dispatch(success(res.result));
                    break;

                case _errorCode.TOKENExpired:
                    functionCommon.logout();
                    break;

                case _errorCode.APIInvalids:
                    functionCommon.logout();
                    break;

                case _errorCode.ClientNotPermission:
                    functionCommon.logout();
                    break;

                default:
                    window.location = "/error/404";
                    break;
            }
        });
    };
    function success(leaveDetail) {
        return { type: leaveDetailConstants.GET_SUCCESS, leaveDetail };
    }
    function loading() {
        return { type: leaveDetailConstants.GET_LIST_DETAIL };
    }
};
